// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { useEffect, useState } from "react";

// JSDOM doesn't implement matchMedia, so this defaults to false (matches
// nothing) in tests rather than throwing - callers relying on this for a
// "collapse on mobile" behavior naturally fall back to their desktop/expanded
// rendering under test.
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() =>
        typeof window.matchMedia === "function" ? window.matchMedia(query).matches : false
    );

    useEffect(() => {
        if (typeof window.matchMedia !== "function") return undefined;
        const mql = window.matchMedia(query);
        const handleChange = (event) => setMatches(event.matches);
        mql.addEventListener("change", handleChange);
        return () => mql.removeEventListener("change", handleChange);
    }, [query]);

    return matches;
}
